angular.module('app.services').service('api', ($rootScope, $q, $http, $httpParamSerializerJQLike, $localStorage, $timeout, Restangular, variables) => (path) => {
    const baseUrl = '/api/1/';
    const cachePrefix = 'cache';
    const getObjectValueByPath = (object, path) => {
        const parts = path.split('.');
        for (let i in parts) {
            const key = parts[i];
            if (object[key]) {
                object = object[key];
            }
        }
        return object;
    };

    const api = {
        requestDefer: null,

        model() {
            return Restangular.all(path);
        },

        stop() {
            this.requestDefer && this.requestDefer.resolve();

            return this;
        },

        buildCacheKey(path) {
            const areaId = $rootScope.$session.area ? $rootScope.$session.area.id : 0;

            return `${cachePrefix}_${areaId}_${path}`;
        },

        _matchLifetimeOptionForKey(path) {
            if ('undefined' !== typeof variables.cacheLifetime.fixed[path]) {
                return variables.cacheLifetime.fixed[path];
            } else {
                for (let pattern in variables.cacheLifetime.regexp) {
                    if (variables.cacheLifetime.regexp.hasOwnProperty(pattern)) {
                        const regexp = new RegExp(pattern, 'g');
                        if (regexp.test(path)) {
                            return variables.cacheLifetime.regexp[pattern];
                        }
                    }
                }
            }

            return variables.cacheLifetime.default;
        },

        list(userOptions) {
            const defaults = {
                data: {},
                method: 'get',
                pathPrefix: '',
                pathSuffix: '',
                cacheLifetime: this._matchLifetimeOptionForKey(path),
            };

            const options = angular.extend({}, defaults, userOptions);

            const deferred = $q.defer();
            const params = $httpParamSerializerJQLike(options.data);
            const suffix = params ? `?${params}` : '';
            const url = baseUrl + options.pathPrefix + path + options.pathSuffix + suffix;
            const now = new Date().getTime();

            const cacheKey = this.buildCacheKey(url);
            const storage = $localStorage;

            if (options.cacheLifetime && 'object' === typeof storage[cacheKey] && storage[cacheKey].lifetime > now) {
                deferred.resolve({ data: storage[cacheKey].data });
                return deferred.promise;
            }

            this.requestDefer = $q.defer();
            $http({
                timeout: this.requestDefer.promise,
                method: options.method,
                url,
            }).then(
                (response) => {
                    if (200 === response.status && response.data) {
                        if (options.cacheLifetime) {
                            storage[cacheKey] = {
                                lifetime: now + options.cacheLifetime,
                                data: response.data,
                            };
                        }
                        deferred.resolve({ data: response.data });
                    } else {
                        deferred.reject();
                    }
                },
                () => {
                    deferred.reject();
                }
            );

            return deferred.promise;
        },

        // coś jak sprintf()
        parse(data, format) {
            if (!format.includes(':')) {
                return data[format];
            }

            const keys = format.match(/\:[a-zA-Z_.]+/gi);
            for (let i in keys) {
                if (keys.hasOwnProperty(i)) {
                    const path = keys[i].substr(1);
                    format = format.replace(keys[i], getObjectValueByPath(data, path));
                }
            }

            return format;
        },

        select(userOptions) {
            const defaults = {
                data: {},
                pathPrefix: 'select/',
                cacheLifetime: this._matchLifetimeOptionForKey(path),
                transform: { id: 'id', value: 'value' },
            };

            const options = angular.extend({}, defaults, userOptions);
            const that = this;

            return that.list(options).then((response) => {
                const pairs = {};

                angular.forEach(response.data, (row) => {
                    pairs[row[options.transform.id]] = that.parse(row, options.transform.value);
                });

                return {
                    data: pairs,
                };
            });
        },

        selectize(userOptions) {
            const defaults = {
                data: {},
                pathPrefix: 'select/',
                cacheLifetime: this._matchLifetimeOptionForKey(path),
                transform: { id: 'id', value: 'value' },
            };

            const options = angular.extend({}, defaults, userOptions);
            const that = this;

            return that.list(options).then((response) => {
                const list = [];

                // must be the same as at selectize.js and angular-selectize.js
                angular.forEach(response.data, (row) => {
                    const baseValues = {
                        value: row[options.transform.id],
                        label: that.parse(row, options.transform.value),
                        order: row.order,
                    };

                    list.push(angular.extend({}, row, baseValues));
                });

                return {
                    data: list,
                };
            });
        },

        filter(userOptions) {
            const defaults = {
                data: {},
                pathPrefix: 'filter/',
            };

            const options = angular.extend({}, defaults, userOptions);

            return this.list(options);
        },

        get(id, userOptions) {
            const defaults = {
                data: {},
                pathPrefix: '',
                pathSuffix: '',
                cacheLifetime: this._matchLifetimeOptionForKey(path),
            };

            const options = angular.extend({}, defaults, userOptions);
            const params = $httpParamSerializerJQLike(options.data);
            const suffix = params ? `?${params}` : '';
            const url = `${baseUrl + options.pathPrefix + path}/${id}${options.pathSuffix}${suffix}`;

            const deferred = $q.defer();

            // todo: cache
            this.requestDefer = $q.defer();
            $http({
                timeout: this.requestDefer.promise,
                method: 'get',
                url,
            }).then(
                (response) => {
                    if (response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject();
                    }
                },
                () => {
                    deferred.reject();
                }
            );

            return deferred.promise;
        },

        save(id, data) {
            const deferred = $q.defer();

            this.requestDefer = $q.defer();
            $http({
                timeout: this.requestDefer.promise,
                method: 'put',
                url: `${baseUrl + path}/${id}`,
                data,
            }).then(
                (response) => {
                    if (200 === response.status && response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject(response.data);
                    }
                },
                (response) => {
                    deferred.reject(response.data);
                }
            );

            return deferred.promise;
        },

        post(data, userOptions) {
            const defaults = {
                pathPrefix: '',
                pathSuffix: '',
                params: {},
                method: 'post',
            };

            const options = angular.extend({}, defaults, userOptions || {});
            const params = $httpParamSerializerJQLike(options.params);
            const suffix = params ? `?${params}` : '';
            const url = baseUrl + options.pathPrefix + path + options.pathSuffix + suffix;

            const deferred = $q.defer();

            this.requestDefer = $q.defer();
            $http({
                timeout: this.requestDefer.promise,
                method: options.method,
                url,
                data,
            }).then(
                (response) => {
                    if (200 === response.status && response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject(response.data);
                    }
                },
                (response) => {
                    deferred.reject(response.data);
                }
            );

            return deferred.promise;
        },

        remove(id, userOptions) {
            const options = angular.extend(
                {
                    method: 'post',
                    pathSuffix: `/delete/${id}`,
                },
                userOptions
            );

            return this.post({}, options);
        },

        restore(id, userOptions) {
            const options = angular.extend(
                {
                    method: 'post',
                    pathSuffix: `/restore/${id}`,
                },
                userOptions
            );

            return this.post({}, options);
        },

        clearCache() {
            const url = baseUrl + path;
            const keyToDelete = this.buildCacheKey(path ? url : '');

            for (let cacheKey in $localStorage) {
                if (0 === cacheKey.indexOf(keyToDelete)) {
                    $localStorage[cacheKey] = '';
                    delete $localStorage[cacheKey];
                }
            }

            return this;
        },

        cancel(promise) {
            return $q.cancel(promise);
        },
    };

    return api;
});
